import React, {useEffect, useState} from "react";
import PilotCard from "./PilotCard";
import styled from "styled-components";
import SearchBarUserName from "../SearchBarUserName";
import useFilterUser from "../../../custom-hooks/useFilterUser";
import {useLocation} from "react-router-dom";
import {GUIDED_UPDATE_PROJECT_ROUTE} from "../../../routes/routesName";


const PilotsSearchBar = ({
                             usersArray = [],
                             data,
                             setData,
                             pilotHasToBeSet = false,
                             setSelectedUser,
                         }) => {

    const [selectedPilot, setSelectedPilot] = useState(0)
    const [usersSelected, setUsersSelected] = useState(usersArray || [])
    const location = useLocation()

    useEffect(() => {
        setUsersSelected(usersArray)
    }, [usersArray])

    useEffect(() => {
        return () => {
            setData(data)
        }
    }, [data, setData])


    useEffect(() => {
        if (!pilotHasToBeSet && selectedPilot) {
            setData(data.filter(p => p.pilot.id === selectedPilot))
        }
    }, [data, pilotHasToBeSet, selectedPilot, setData])


    useEffect(() => {
        if (pilotHasToBeSet && selectedPilot) {
            setSelectedUser(selectedPilot)
        }
    }, [pilotHasToBeSet, selectedPilot, setSelectedUser])

    const {
        query,
        setQuery,
        getFullNameInverseNoWhiteSpace,
        getFullNameNoWhiteSpace,
        getQueryNoWhiteSpace
    } = useFilterUser(usersSelected)


    const displayUsers = () => {
        if (usersArray.length > 0) {
            return (
                <SearchBar className={"search-bar-user"}>
                    {usersSelected
                        .filter(u =>
                            u.firstName.toLowerCase().includes(query.toLowerCase()) ||
                            u.lastName.toLowerCase().includes(query.toLowerCase()) ||
                            getFullNameNoWhiteSpace(u).includes(getQueryNoWhiteSpace(query)) ||
                            getFullNameInverseNoWhiteSpace(u).includes(getQueryNoWhiteSpace(query))
                        )
                        .map((p) => (
                            <Card key={p.id} onClick={() => setSelectedPilot(p.id)}>
                                <PilotCard
                                    id={p.id}
                                    firstName={p.firstName}
                                    lastName={p.lastName}
                                    picture={p.photo}
                                    selectedPilot={selectedPilot}
                                />
                            </Card>

                        ))}
                </SearchBar>
            )
        }
    }
    return (
        <Container>
            {!location.pathname.startsWith(GUIDED_UPDATE_PROJECT_ROUTE) &&
            <SearchBarUserName
                setQuery={setQuery}
            />
            }

            {displayUsers()}

        </Container>

    )
}


const Card = styled.div`
  border-radius: 15px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;

  p {
    font-size: 60%;
    overflow: hidden;
    text-overflow: ellipsis;
    width: 90%;
    text-align: center;
    line-height: normal;
    padding-top: 0.5em;
    height: 100%;
    font-weight: 600;
    flex-grow: 1;
  }
`
const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  align-items: center;
  width: 100%;
  input[type="text"]{
  width: 400px;
  }
`

const SearchBar = styled.div`
  display: flex;
  flex-direction: row;
  overflow-x: scroll;
  margin: 0 0.5em;
  max-width: 100%;
`

export default PilotsSearchBar;